import React from 'react';
import { Link } from 'react-router-dom';

const GoodDataManagementPage = () => {
  return (
    <div>
      {/* Article Header */}
      <section
        className="h-[42vh] sm:h-[49vh] md:h-[56vh] bg-cover bg-center bg-no-repeat relative"
        style={{
          backgroundImage: "url('/images/LJM-Blog-Images-2.webp')"
        }}
      >
        {/* Overlay */}
        <div
          className="absolute inset-0"
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
        />

        {/* Banner Content */}
        <div className="relative z-10 flex items-center h-full px-4 sm:px-8 md:px-16 lg:px-24">
          <div className="text-center text-white max-w-6xl mx-auto">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-normal mb-4 sm:mb-6 leading-tight text-white">
              What does good data<br />
              management look like?
            </h1>
          </div>
        </div>
      </section>

      {/* Article Content */}
      <section className="py-8 sm:py-10 md:py-12 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="blog_inner">
            <div className="blog_lift_sidebar">
              <div className="blog_items">
                <div className="prose prose-lg max-w-none">
                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    In marketing, having a data management plan is crucial for all organisation sizes as it is used to provide valuable insight which will strengthen consumer relationships.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    In the modern economy, we have access to more data than ever. This data creates a foundation for important decisions which will impact the future of your business. To people have the right data for decision-making, companies must invest in data management solutions that improve all business functions effectively.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    What is it?
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    Data management is the process of acquiring, storing, protecting and retaining the data which has been generated by an organisation. Here at Lloyd James, we have our own platform which has helped our customers use their data intelligently. By using our own in-house rules, we have enhanced our customer data management systems to merge all contributor data into one single view. <Link to="/data-consultancy" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>Click here</Link> to learn about our company mission.
                  </p>

                  <p className="text-xl font-semibold text-gray-900 mb-4">
                    Importance of database management software
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    For customer-focused businesses, using data management services such as data quality management are essential as it ensures data is updated and regularly checked. For a CRM system, this is especially important as old data will be removed from the system.
                  </p>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    It is also important to consider data lifecycle management, a process which helps a company to maintain its data flow. The five stages of the data life cycle are:
                  </p>

                  <ol className="list-decimal pl-6 text-gray-700 leading-relaxed mb-6 text-lg">
                    <li className="mb-2"><strong>Data Creation</strong></li>
                    <li className="mb-2"><strong>Data Storage</strong></li>
                    <li className="mb-2"><strong>Data Usage</strong></li>
                    <li className="mb-2"><strong>Data Archive</strong></li>
                    <li className="mb-2"><strong>Data Destruction</strong></li>
                  </ol>

                  <p className="text-gray-700 leading-relaxed mb-6 text-lg">
                    There are various solutions which will ensure a company has an up-to-date database with a controlled data lifecycle to ensure that data in a system is being stored and used effectively. At Lloyd James we are here to build on what you do know and expand on what you don't. For any queries, please <Link to="/contact" className="text-pink-600 hover:text-pink-700 underline" onClick={() => window.scrollTo(0, 0)}>click here</Link> to request a call back.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default GoodDataManagementPage;